var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.recaudacionesConsultadas &&
                      !_vm.mostrandoAsignaciones &&
                      !_vm.asignandoItems,
                    expression:
                      "\n          !recaudacionesConsultadas &&\n          !mostrandoAsignaciones &&\n          !asignandoItems\n        "
                  }
                ],
                staticClass: "btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.asignarItems }
              },
              [
                _c("i", { staticClass: "fa fa-table" }),
                _c("span", [_vm._v("Asignación de ítems")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.mostrandoAsignaciones && !_vm.asignandoItems,
                    expression: "!mostrandoAsignaciones && !asignandoItems"
                  }
                ],
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.recaudacionesAsignadas }
              },
              [
                _c("i", { staticClass: "fa fa-list" }),
                _c("span", [_vm._v("Recaudaciones asignadas")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.asignandoItems || _vm.mostrandoAsignaciones,
                    expression: "asignandoItems || mostrandoAsignaciones"
                  }
                ],
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.asignandoItems || _vm.mostrandoAsignaciones,
                    expression: "asignandoItems || mostrandoAsignaciones"
                  }
                ],
                staticClass: "btn-danger btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.cancelarAsignacionItems }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _c("span", [_vm._v("Cancelar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-2" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.cambiarOrden && !_vm.asignandoItems,
                    expression: "!cambiarOrden && !asignandoItems"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo_fecha,
                            expression: "form.tipo_fecha"
                          }
                        ],
                        attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "tipo_fecha",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "H" } }, [
                          _vm._v("Hoy")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "A" } }, [
                          _vm._v("Ayer")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "P" } }, [
                          _vm._v("Personalizada")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "tipo_fecha" } }, [
                      _vm._v("Tipo de fecha")
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.form.tipo_fecha === "P" &&
                      !_vm.cambiarOrden &&
                      !_vm.asignandoItems,
                    expression:
                      "form.tipo_fecha === 'P' && !cambiarOrden && !asignandoItems"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.form.tipo_fecha === "P" &&
                      !_vm.cambiarOrden &&
                      !_vm.asignandoItems,
                    expression:
                      "form.tipo_fecha === 'P' && !cambiarOrden && !asignandoItems"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "hasta",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cambiarOrden || _vm.asignandoItems,
                    expression: "cambiarOrden || asignandoItems"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "fecha",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha...",
                          disabled:
                            _vm.recaudacionesConsultadas && _vm.asignandoItems
                        },
                        model: {
                          value: _vm.form.fecha,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha", $$v)
                          },
                          expression: "form.fecha"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Fecha")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cambiarOrden || _vm.asignandoItems,
                    expression: "cambiarOrden || asignandoItems"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.dia_cobro,
                            expression: "form.dia_cobro"
                          }
                        ],
                        attrs: { name: "dia_cobro", id: "dia_cobro" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "dia_cobro",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v("Seleccione...")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("Lunes")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "2" } }, [
                          _vm._v("Martes")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "3" } }, [
                          _vm._v("Miércoles")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "4" } }, [
                          _vm._v("Jueves")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "5" } }, [
                          _vm._v("Viernes")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "6" } }, [
                          _vm._v("Sábado")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "7" } }, [
                          _vm._v("Domingo")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "dia_cobro" } }, [
                      _vm._v("Día de cobro")
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.cambiarOrden ||
                      _vm.asignandoItems ||
                      _vm.mostrandoAsignaciones,
                    expression:
                      "cambiarOrden || asignandoItems || mostrandoAsignaciones"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "form-field select2",
                    class: {
                      "select2--disabled": _vm.recaudacionesConsultadas
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            placeholder: "Seleccione...",
                            options: _vm.rutas,
                            id: "ruta",
                            name: "ruta",
                            label: "descripcion"
                          },
                          on: { input: _vm.inputRuta, search: _vm.searchRutas },
                          model: {
                            value: _vm.selectedRuta,
                            callback: function($$v) {
                              _vm.selectedRuta = $$v
                            },
                            expression: "selectedRuta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "ruta" } }, [
                          _vm._v("Ruta")
                        ])
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        options: _vm.recaudadores,
                        id: "recaudador",
                        name: "recaudador",
                        label: "nombre"
                      },
                      on: {
                        input: _vm.inputRecaudador,
                        search: _vm.searchRecaudadores
                      },
                      model: {
                        value: _vm.selectedRecaudador,
                        callback: function($$v) {
                          _vm.selectedRecaudador = $$v
                        },
                        expression: "selectedRecaudador"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "recaudador" } }, [
                      _vm._v("Recaudador")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostrandoAsignaciones,
                    expression: "mostrandoAsignaciones"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          id: "bodega_id",
                          options: _vm.bodegas
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodega_id" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.asignandoItems,
                    expression: "asignandoItems"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          options: _vm.supervisores,
                          id: "supervisor",
                          name: "supervisor",
                          label: "nombre"
                        },
                        on: {
                          input: _vm.inputSupervisor,
                          search: _vm.searchSupervisores
                        },
                        model: {
                          value: _vm.selectedSupervisor,
                          callback: function($$v) {
                            _vm.selectedSupervisor = $$v
                          },
                          expression: "selectedSupervisor"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "supervisor" } }, [
                        _vm._v("Supervisor")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.asignandoItems && _vm.recaudacionesConsultadas,
                    expression: "asignandoItems && recaudacionesConsultadas"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "referencia_movimiento",
                            readonly: _vm.form.items.length > 0,
                            placeholder: "Referencia de movimiento..."
                          },
                          model: {
                            value: _vm.form.referencia_movimiento,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "referencia_movimiento", $$v)
                            },
                            expression: "form.referencia_movimiento"
                          }
                        },
                        [_vm._v("\n                Movimiento\n              ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.items.length == 0,
                              expression: "form.items.length == 0"
                            }
                          ],
                          staticClass: "btn-success btn--text",
                          attrs: { type: "button" },
                          on: { click: _vm.confirmarMovimiento }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Confirmar")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.items.length > 0,
                              expression: "form.items.length > 0"
                            }
                          ],
                          staticClass: "btn-danger btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.quitarMovimiento()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-times" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Anular")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.items.length > 0,
                              expression: "form.items.length > 0"
                            }
                          ],
                          staticClass: "btn-success btn--text",
                          attrs: { type: "button" },
                          on: { click: _vm.actualizarRecaudacion }
                        },
                        [
                          _c("i", { staticClass: "fa fa-save" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Actualizar")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-info btn--text",
                          attrs: { type: "button" },
                          on: { click: _vm.verMovimiento }
                        },
                        [
                          _c("i", { staticClass: "fa fa-eye" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ver")])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.cambiarOrden &&
                      !_vm.asignandoItems &&
                      !_vm.mostrandoAsignaciones,
                    expression:
                      "!cambiarOrden && !asignandoItems && !mostrandoAsignaciones"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          id: "consulta",
                          placeholder: "Número de documento o cliente..."
                        },
                        model: {
                          value: _vm.form.consulta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "consulta", $$v)
                          },
                          expression: "form.consulta"
                        }
                      },
                      [_vm._v("\n              Consulta\n            ")]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.asignandoItems && _vm.form.recaudacion_id != "",
              expression: "asignandoItems && form.recaudacion_id != ''"
            }
          ],
          staticClass: "card mt-2 mb-2"
        },
        [
          _c(
            "div",
            { staticClass: "card__content" },
            [
              _c("items-adicionales", {
                attrs: {
                  ruta_id: _vm.form.ruta_id,
                  recaudacionId: _vm.form.recaudacion_id
                },
                model: {
                  value: _vm.form.movimientosAdicionales,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "movimientosAdicionales", $$v)
                  },
                  expression: "form.movimientosAdicionales"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("k-table", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              !_vm.cambiarOrden &&
              !_vm.asignandoItems &&
              !_vm.mostrandoAsignaciones,
            expression:
              "!cambiarOrden && !asignandoItems && !mostrandoAsignaciones"
          }
        ],
        ref: "recaudaciones",
        attrs: {
          params: _vm.form,
          buttons: [
            {
              event: "verVisita",
              icon: "fa-table",
              class: "btn-info btn--text",
              text: "Visita"
            },
            {
              event: "verVenta",
              icon: "fa-eye",
              class: "btn-success btn--text",
              text: "Venta"
            }
          ],
          buscarButton: false,
          filterStatus: false,
          path: _vm.path,
          createButton: false,
          editButton: false,
          deleteButton: false,
          columns: [
            {
              display: "Fecha de venta",
              value: "fecha"
            },
            {
              display: "Ruta",
              value: "descripcion_ruta"
            },
            {
              display: "Vendedor",
              value: "descripcion_vendedor"
            },
            {
              display: "Fecha de recaudación",
              value: "fecha_recaudacion"
            },
            {
              display: "Día de recaudación",
              value: "descripcion_dia_cobro"
            },
            {
              display: "Tipo",
              value: "tipo_documento"
            },
            {
              display: "# Cartilla",
              value: "numero_documento"
            },
            {
              display: "Recaudador",
              value: "nombre_recaudador"
            },
            {
              display: "Cliente",
              value: "nombre_cliente"
            },
            {
              display: "Observación",
              value: "observación"
            },
            {
              display: "# Pagos",
              value: "numero_pagos"
            },
            {
              display: "Venta total",
              value: "venta_total"
            },
            {
              display: "V. Pagos",
              value: "valor_pagos"
            },
            {
              display: "Saldo",
              value: "saldo_total"
            }
          ]
        },
        on: { verVisita: _vm.verVisita, verVenta: _vm.verVenta }
      }),
      _vm._v(" "),
      _c("k-table", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mostrandoAsignaciones,
            expression: "mostrandoAsignaciones"
          }
        ],
        ref: "recaudacionesAsignadas",
        attrs: {
          buttons: [
            {
              event: "verItems",
              icon: "fa-list",
              class: "btn-info btn--text",
              text: "´Ítems"
            },
            {
              event: "verCartillas",
              icon: "fa-table",
              class: "btn-primary btn--text",
              text: "Cartillas"
            },
            {
              event: "verRubros",
              icon: "fa-money",
              class: "btn-secondary btn--text",
              text: "Rubros"
            },
            {
              event: "exportar",
              icon: "fa-file-excel-o",
              class: "btn-success btn--text",
              text: "Exportar"
            },
            {
              event: "reportar",
              icon: "fa-share",
              class: "btn-warning btn--text",
              text: "Reportar"
            },
            {
              event: "anular",
              icon: "fa-trash",
              class: "btn-danger btn--text",
              text: "Anular"
            }
          ],
          params: _vm.form,
          buscarButton: false,
          filterStatus: false,
          path: _vm.pathRecaudaciones,
          createButton: false,
          editButton: false,
          deleteButton: false,
          columns: [
            {
              display: "Fecha",
              value: "fecha_formateada"
            },
            {
              display: "Ref. Movimiento",
              value: "referencia_movimiento"
            },
            {
              display: "Recaudador",
              value: "recaudador.nombre"
            },
            {
              display: "Ruta",
              value: "ruta.nombre"
            },
            {
              display: "Día de cobro",
              value: "descripcion_dia_cobro"
            },
            {
              display: "Estado",
              value: "estado_recaudacion"
            },
            {
              display: "Creador",
              value: "creador.nombre"
            },
            {
              display: "Creación",
              value: "created_at"
            },
            {
              display: "Modificador",
              value: "modificador.nombre"
            },
            {
              display: "Fecha inicio",
              value: "fecha_inicio"
            },
            {
              display: "Fecha fin",
              value: "fecha_fin"
            }
          ]
        },
        on: {
          reportar: _vm.reportar,
          anular: _vm.anularRecaudacion,
          verItems: _vm.verItems,
          verCartillas: _vm.verCartillas,
          verRubros: _vm.verRubros,
          exportar: _vm.exportar
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (_vm.cambiarOrden || _vm.asignandoItems) &&
                !_vm.mostrandoAsignaciones,
              expression:
                "(cambiarOrden || asignandoItems) && !mostrandoAsignaciones"
            }
          ],
          staticClass: "card"
        },
        [
          _c("div", { staticClass: "card__content" }, [
            _c("table", [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.recaudaciones, function(recaudacion, index) {
                    return _c("tr", { key: recaudacion.id }, [
                      _c("td", [_vm._v(_vm._s(index + 1))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.fecha) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.fecha_recaudacion) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.descripcion_dia_cobro) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.tipo_documento) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.numero_documento) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.nombre_cliente) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.observacion) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(recaudacion.numero_pagos) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.moneyFormat(recaudacion.venta_total)) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.moneyFormat(recaudacion.valor_pagos)) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.moneyFormat(recaudacion.saldo)) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index > 0 && !_vm.asignandoItems,
                                expression: "index > 0 && !asignandoItems"
                              }
                            ],
                            staticClass: "btn-primary btn--text",
                            on: {
                              click: function($event) {
                                return _vm.subir(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-arrow-up" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  index < _vm.recaudaciones.length - 1 &&
                                  !_vm.asignandoItems,
                                expression:
                                  "index < recaudaciones.length - 1 && !asignandoItems"
                              }
                            ],
                            staticClass: "btn-primary btn--text",
                            on: {
                              click: function($event) {
                                return _vm.bajar(index)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-arrow-down" })]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.recaudaciones.length === 0,
                          expression: "recaudaciones.length === 0"
                        }
                      ]
                    },
                    [
                      _c("td", { attrs: { colspan: "10" } }, [
                        _vm._v("No hay resultados disponibles.")
                      ])
                    ]
                  )
                ],
                2
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "itemsRecaudaciones",
            height: "auto",
            width: "60%",
            scrollable: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("items-recaudaciones", {
            attrs: {
              ruta_id: _vm.form.ruta_id,
              soloConsulta: _vm.consultaItemsRecaudaciones,
              referenciaMovimiento: _vm.form.referencia_movimiento
            },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("itemsRecaudaciones")
              },
              aceptar: _vm.aceptarItems
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "itemsConsultaRecaudaciones",
            height: "auto",
            width: "60%",
            scrollable: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("items-consulta-recaudaciones", {
            attrs: { recaudacionId: _vm.currentRecaudacionId },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("itemsConsultaRecaudaciones")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "cartillasRecaudacion",
            width: "80%",
            height: "auto",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("cartillas-recaudacion", {
            attrs: { recaudacionId: _vm.currentRecaudacionId },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("cartillasRecaudacion")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "rubrosRecaudacion",
            width: "80%",
            height: "auto",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("rubros-recaudacion", {
            attrs: { recaudacionId: _vm.currentRecaudacionId },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("rubrosRecaudacion")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "rec" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Recaudaciones")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Orden")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de venta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de recaudación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Día de recaudación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Cartilla")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Observación")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Venta total")]),
        _vm._v(" "),
        _c("th", [_vm._v("V. Pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ed920c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed920c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/Recaudaciones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3ed920c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/Recaudaciones.vue
// module chunks = 0